


import { RevolvaService } from './revolva.service';
import * as THREE from "three";
import * as actions from "@/service/revolva.action";

export function loadGround(service: RevolvaService) {
    const { scene } = service
    const loader = new THREE.TextureLoader();
    const groundTexture = loader.load('../../textures/ground.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(1, 1);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;

    const groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    const mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.5, 1.5), groundMaterial);
    mesh.position.y = - 0;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    scene.add(mesh);
}

export function changDial(service: RevolvaService, color: string){
    const { scene,  pieces,  piecesInScene } = service
    scene.remove(piecesInScene['piece2']);
    scene.remove(piecesInScene['piece4']);
    scene.remove(piecesInScene['piece5']);
    if(color === 'black'){
        piecesInScene['piece2'] = pieces[23];
        piecesInScene['piece4'] = pieces[24];
        piecesInScene['piece5'] = pieces[25];
    }
    if(color === 'blue'){
        piecesInScene['piece2'] = pieces[34];
        piecesInScene['piece4'] = pieces[24];
        piecesInScene['piece5'] = pieces[25];
    }
    if(color === 'grey'){
        piecesInScene['piece2'] = pieces[31];
        piecesInScene['piece4'] = pieces[32];
        piecesInScene['piece5'] = pieces[33];
    }
    
    scene.add(piecesInScene['piece2']);
    scene.add(piecesInScene['piece4']);
    scene.add(piecesInScene['piece5']);
}


export function seeInside(service: RevolvaService) {
    const { scene, finishedLoading3D, piecesInScene, seeInside } = service
    if (finishedLoading3D) {
        if (seeInside) {
            //scene.remove(piecesInScene["piece7"]);
            scene.remove(piecesInScene["piece2"]);
        } else {
            //scene.add(piecesInScene["piece7"]);
            scene.add(piecesInScene["piece2"]);
        }
        actions.renderModel(service);
    }
}


export function watchAnimation(service: RevolvaService) {
    const { piecesInScene } = service
    const curdate = new Date();
    console.log(curdate.getMinutes())
    piecesInScene["piece5"].rotation.z =
        (-(((curdate.getSeconds() / 60 + curdate.getMinutes()) / 60) * 360) *
            Math.PI) /
        180;
    piecesInScene["piece4"].rotation.z =
        (-(((curdate.getHours() + curdate.getMinutes() / 60) / 12) * 360) *
            Math.PI) /
        180;
    piecesInScene["piece6"].rotation.z =
        (-(
            ((curdate.getSeconds() + curdate.getMilliseconds() / 1000) / 60) *
            360
        ) *
            Math.PI) /
        180;
      /*   piecesInScene["piece6"].rotation.z =
        (-(
            (curdate.getSeconds()  / 60) *
            360
        ) *
            Math.PI) /
        180; */
}

export function rotatMesh(service: RevolvaService) {
    console.log('piece8')
    const { piecesInScene } = service
    const curdate = new Date();
    const day = (curdate.getDate() -15);
    if(curdate.getDate()  === 1){
        piecesInScene["piece8"].rotation.z = -0.201 * day;    }
    if(curdate.getDate()  === 2){
        piecesInScene["piece8"].rotation.z = -0.201 * day;
    }
    if(curdate.getDate()  === 3){
        piecesInScene["piece8"].rotation.z = -0.2015 * day;
    }
    if(curdate.getDate()  === 4){
        piecesInScene["piece8"].rotation.z = -0.2015 * day;
    }
    if(curdate.getDate()  === 5){
        piecesInScene["piece8"].rotation.z = -0.2018 * day;
    }
    if(curdate.getDate()  === 6){
        piecesInScene["piece8"].rotation.z = -0.2018 * day;
    }
    if(curdate.getDate()  === 7){
        piecesInScene["piece8"].rotation.z = -0.2019 * day;
    }
    if(curdate.getDate()  === 8){
        piecesInScene["piece8"].rotation.z = -0.2019 * day;
    }
    if(curdate.getDate()  === 9){
        piecesInScene["piece8"].rotation.z = -0.202 * day;
    }
    if(curdate.getDate()  === 10){
        piecesInScene["piece8"].rotation.z = -0.202 * day;
    }
    if(curdate.getDate()  === 11){
        piecesInScene["piece8"].rotation.z = -0.2021 * day;
    }
    if(curdate.getDate()  === 12){
        piecesInScene["piece8"].rotation.z = -0.2021 * day;
    }
    if(curdate.getDate()  === 13){
        piecesInScene["piece8"].rotation.z = -0.2022 * day;
    }
    if(curdate.getDate()  === 14){
        piecesInScene["piece8"].rotation.z = -0.2025 * day;
    }
    if(curdate.getDate()  === 15){
        piecesInScene["piece8"].rotation.z = -0.2025 * day;
    }
    if(curdate.getDate()  === 16){
        piecesInScene["piece8"].rotation.z = -0.20 * day;
    }
    if(curdate.getDate()  === 17){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 18){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 19){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 20){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 21){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 22){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 23){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 24){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 25){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 26){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 27){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 28){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }

    if(curdate.getDate()  === 29){
        piecesInScene["piece8"].rotation.z = -0.2039 * day;
    }
    if(curdate.getDate()  === 30){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
    if(curdate.getDate()  === 31){
        piecesInScene["piece8"].rotation.z = -0.204 * day;
    }
}